const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${user.token}`
  };
};

/**
 * Public payment settings for booking thank-you screen
 */
export const getPaymentSettings = async () => {
  const response = await fetch(`${API_BASE_URL}/payment-settings`);
  if (!response.ok) {
    throw new Error('Failed to fetch payment settings');
  }
  return response.json();
};

/**
 * Full payment settings including inactive channels (admin)
 */
export const getPaymentSettingsAdmin = async () => {
  const response = await fetch(`${API_BASE_URL}/payment-settings/admin`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to fetch payment settings');
  }
  return response.json();
};

export const updateAdminEmail = async (adminEmail) => {
  const response = await fetch(`${API_BASE_URL}/payment-settings/admin-email`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ adminEmail })
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to update admin email');
  }
  return response.json();
};

export const createPaymentChannel = async (data) => {
  const response = await fetch(`${API_BASE_URL}/payment-settings/channels`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to create payment channel');
  }
  return response.json();
};

export const updatePaymentChannel = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/payment-settings/channels/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to update payment channel');
  }
  return response.json();
};

export const deletePaymentChannel = async (id) => {
  const response = await fetch(`${API_BASE_URL}/payment-settings/channels/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to delete payment channel');
  }
  return response.json();
};
